module.exports = __webpack_public_path__ + "img/dfda5da.png";